module.exports = __webpack_public_path__ + "img/update--video-chara.1f5993bc.png";